import request from './request';

export default {
	async getFavoriteDestinations() {
		const res = await request.get('/app/favorite-destinations');
		return res;
	},
	async createFavoriteDestinations(body) {
		const res = await request.post('/app/favorite-destinations', body);
		return res;
	},
	async deleteFavoriteDestinationsById(id) {
		const res = await request.delete(`/app/favorite-destinations/id?id=${id}`);
		return res;
	}
};
